import { useState, useEffect, useRef } from "react";
import { fileUrl } from "@/lib/api";

const PLACEHOLDER = "https://images.unsplash.com/photo-1522065893269-6fd20f6d7438?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

/**
 * Smoothly cross-fades through up to N images every `interval` ms.
 * A single image renders statically (no animation).
 */
export function ImageCarousel({ images, alt = "", className = "", interval = 2600, imgClassName = "", dotsClassName = "" }) {
  const list = images && images.length > 0 ? images : [PLACEHOLDER];
  const [index, setIndex] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    if (list.length <= 1) return;
    timer.current = setInterval(() => {
      setIndex((i) => (i + 1) % list.length);
    }, interval);
    return () => clearInterval(timer.current);
  }, [list.length, interval]);

  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="image-carousel">
      {list.map((src, i) => (
        <img
          key={i}
          src={fileUrl(src)}
          alt={alt}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms] ease-in-out ${imgClassName} ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
          style={{ transitionProperty: "opacity, transform" }}
        />
      ))}
      {/* keeps the container sized */}
      <img src={fileUrl(list[0])} alt="" aria-hidden className="w-full h-full object-cover opacity-0 pointer-events-none" />
      {list.length > 1 && (
        <div className={`absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10 transition-opacity duration-300 ${dotsClassName}`} data-testid="carousel-dots">
          {list.map((_, i) => (
            <span key={i}
              className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? "w-4 bg-white" : "w-1.5 bg-white/60"}`} />
          ))}
        </div>
      )}
    </div>
  );
}
